import {
  AnchorItemKey,
  GeneralInformationData,
} from '@/features/ap_payees/components/PayeeDetailDrawer/types';
import { useTranslation } from '@/i18n';
import classnames from 'classnames/bind';
import { FC, useMemo } from 'react';
import styles from '../../styles.module.scss';
import { HeaderSection, SingleRow } from '../Common';

const cx = classnames.bind(styles);

type GeneralInformationProps = {
  data?: GeneralInformationData | undefined;
};

export const GeneralInformation: FC<GeneralInformationProps> = ({ data }) => {
  const { t } = useTranslation();
  const handleData = useMemo(() => {
    return [
      {
        label: t('ap_payee_name_and_code'),
        value: data?.display_name,
      },
    ];
  }, [data?.display_name, t]);
  return (
    <div
      id={AnchorItemKey.GENERAL_INFORMATION}
      className={cx('sectionContainer')}
    >
      <HeaderSection
        displayName={t('ap_payee_detail_drawer_general_information')}
      />
      <div className={cx('bodySectionContainer')}>
        {handleData.map((item, index) => (
          <SingleRow
            key={`${item.label}-${index}`}
            label={item.label}
            value={item.value ?? ''}
          />
        ))}
      </div>
    </div>
  );
};

GeneralInformation.displayName = 'GeneralInformation';
